
import apiRequest from "./apiRequest";

export const mgt1Api = {

    fetchMgt1Register: (accountId, token) => {
    return apiRequest(`/api/register/mgt1?accountId=${accountId}`, 'GET', token);
  },

   fetchMgt1ShareSummary: (accountId, token) => {
    return apiRequest(
      `/api/register/mgt1/share-summary?accountId=${accountId}`,
      "GET",
      token
    );
  },

   addNewShareHolding: (mgt1Id, payload, token) => {
    return apiRequest(
      `/api/register/mgt1/add-new/shareholding?mgt1Id=${mgt1Id}`,
      "POST",
      token,
      payload          // ← body is forwarded as-is to apiRequest
    );
  },
  

  // Submit MGT-1 form data
  submitMgt1Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mgt1?accountId=${accountId}`, 'POST', token, formData);
  },

  // Submit MGT-1 form data
  submitMgt1Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mgt1?accountId=${accountId}`, 'POST', token, formData);
  },

  
};